export const offlineClientsPage = (clients: any[]) => `
<!DOCTYPE html>
<html lang="nl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Maes & Partners - Overzicht</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            background-color: #f3f4f6;
            padding: 2rem 1rem;
            min-height: 100vh;
        }
        
        .container {
            max-width: 1200px;
            margin: 0 auto;
        }
        
        .card {
            background: white;
            border-radius: 0.5rem;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            overflow: hidden;
        }
        
        .header {
            background-color: rgb(9, 54, 91);
            padding: 1.5rem;
        }
        
        .header h1 {
            color: white;
            font-size: 1.5rem;
            font-weight: bold;
        }
        
        .search-container {
            padding: 1.5rem;
            background-color: #f9fafb;
            border-bottom: 1px solid #e5e7eb;
        }
        
        .search-input {
            width: 100%;
            padding: 0.75rem 1rem;
            border: 1px solid #d1d5db;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            transition: border-color 0.15s, box-shadow 0.15s;
        }
        
        .search-input:focus {
            outline: none;
            border-color: rgb(9, 54, 91);
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }
        
        .table-container {
            overflow-x: auto;
        }
        
        table {
            width: 100%;
            border-collapse: collapse;
        }
        
        thead {
            background-color: #f9fafb;
        }
        
        th {
            padding: 0.75rem 1.5rem;
            text-align: left;
            font-size: 0.75rem;
            font-weight: 500;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }
        
        tbody tr {
            border-top: 1px solid #e5e7eb;
            transition: background-color 0.15s;
        }
        
        tbody tr:hover {
            background-color: #f9fafb;
        }
        
        td {
            padding: 1rem 1.5rem;
            font-size: 0.875rem;
            color: #374151;
        }
        
        td:first-child {
            font-weight: 500;
            color: #111827;
        }
        
        .link {
            color: rgb(9, 54, 91);
            text-decoration: none;
            transition: color 0.15s;
        }
        
        .link:hover {
            color: #1e40af;
            text-decoration: underline;
        }
        
        .footer {
            padding: 1rem 1.5rem;
            background-color: #f9fafb;
            border-top: 1px solid #e5e7eb;
            font-size: 0.875rem;
            color: #6b7280;
        }
        
        .footer span {
            font-weight: 600;
        }
        
        .no-results {
            padding: 3rem 1.5rem;
            text-align: center;
            color: #6b7280;
            font-size: 0.875rem;
        }
        
        .loading {
            padding: 3rem 1.5rem;
            text-align: center;
            color: #6b7280;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="card">
            <div class="header">
                <h1>Maes & Partners - Overzicht</h1>
            </div>
            
            <div class="search-container">
                <input 
                    type="text" 
                    id="searchInput" 
                    class="search-input" 
                    placeholder="Zoeken op naam, bedrijf of BKH..."
                    autocomplete="off"
                >
            </div>
            
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Bedrijf</th>
                            <th>BKH</th>
                            <th>Map</th>
                        </tr>
                    </thead>
                    <tbody id="tableBody">
                        <tr>
                            <td colspan="4" class="loading">Gegevens laden...</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div class="footer">
                <p>Totaal: <span id="totalCount">0</span> items <span id="filteredInfo"></span></p>
            </div>
        </div>
    </div>

    <script>
        let orig = ${JSON.stringify(clients)};
        let allData = orig.map(item => ({
            naam: item.firstName + ' ' + item.lastName,
            bedrijf: (item.company || {}).name || '-',
            bkh: (item.company || {}).bkh || '-',
            map: (item.company || {}).bkh ? \`localexplorer:O:\\\\\${item.company.bkh}\` : '-'
        }));
        let filteredData = [];


        // Render table rows
        function renderTable() {
            const tbody = document.getElementById('tableBody');
            
            if (filteredData.length === 0) {
                tbody.innerHTML = '<tr><td colspan="4" class="no-results">Geen resultaten gevonden</td></tr>';
                return;
            }
            
            tbody.innerHTML = filteredData.map(item => \`
                <tr>
                    <td>\${escapeHtml(item.naam)}</td>
                    <td>\${escapeHtml(item.bedrijf)}</td>
                    <td>\${escapeHtml(item.bkh)}</td>
                    <td>
                        <a href="\${item.map}" target="_blank" class="link">
                            📁 Open map
                        </a>
                    </td>
                </tr>
            \`).join('');
        }

        // Update count display
        function updateCount() {
            document.getElementById('totalCount').textContent = allData.length;
            const filteredInfo = document.getElementById('filteredInfo');
            
            if (filteredData.length < allData.length) {
                filteredInfo.textContent = \`(\${filteredData.length} weergegeven)\`;
            } else {
                filteredInfo.textContent = '';
            }
        }

        // Search functionality
        function performSearch() {
            const searchTerm = document.getElementById('searchInput').value.toLowerCase().trim();
            
            if (searchTerm === '') {
                filteredData = allData;
            } else {
                filteredData = allData.filter(item => 
                    item.naam.toLowerCase().includes(searchTerm) ||
                    item.bedrijf.toLowerCase().includes(searchTerm) ||
                    item.bkh.toLowerCase().includes(searchTerm)
                );
            }
            
            renderTable();
            updateCount();
        }

        // Escape HTML to prevent XSS
        function escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        }

        // Event listeners
        document.getElementById('searchInput').addEventListener('input', performSearch);

                filteredData = allData;
                renderTable();
                updateCount();
    </script>
</body>
</html>
`;
